module.exports = __webpack_public_path__ + "img/Stories TV.645e62ad.svg";